// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PinterestIconSignature {
  Element: SVGSVGElement;
}

export const PinterestIcon: TOC<PinterestIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M12.4 2C6.9 2 4 5.5 4 9.3C4 11.1 5 13.3 6.6 14C6.8 14.1 7 14.1 7 13.8C7 13.6 7.3 12.8 7.4 12.4C7.4 12.3 7.4 12.2 7.3 12.1C6.8 11.5 6.4 10.4 6.4 9.3C6.4 6.6 8.5 4 12.1 4C15.2 4 17.4 6 17.4 8.9C17.4 12.2 15.7 14.5 13.4 14.5C12.2 14.5 11.2 13.5 11.5 12.3C11.9 10.9 12.6 9.3 12.6 8.3C12.6 7.4 12.1 6.6 11 6.6C9.7 6.6 8.7 7.9 8.7 9.5C8.7 10.6 9.1 11.3 9.1 11.3C9.1 11.3 7.8 16.4 7.6 17.3C7.2 18.9 7.7 21.5 7.7 21.7C7.7 21.8 7.9 21.9 7.9 21.8C8 21.6 9.5 19.5 10 17.9C10.2 17.3 10.8 15 10.8 15C11.2 15.8 12.4 16.4 13.7 16.4C17.5 16.4 20.3 13 20.3 8.9C20.2 5 16.8 2 12.4 2Z"/>
</svg>
</template>;